qw-booking-bar {
  width: auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0 auto;
  background-color: var(--qw-hotel-neutral-lightest);
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  position: relative;
  &.booking--searched {
    .qw-booking-bar__input-fields > qw-input {
      pointer-events: none;
    }
    .qw-booking-bar__label--search {
      @media only screen and (max-width: 1280px) {
        display: none;
      }
    }
    .qw-booking-bar__input-fields > qw-input:nth-of-type(4) {
      @media only screen and (max-width: 1024px) {
        display: none;
      }
    }
  }

  qw-room-type-list {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.26);
    border: solid 2px #414445;
    border-radius: 5px;
    padding: 26px 30px;
  }
}

qw-booking-bar.change-location {
  pointer-events: none;
}
qw-booking-bar.change-location:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  z-index: 3;
  border-radius: 5px;
  opacity: 0.4;
}

qw-booking-bar.change-location:before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--qw-hotel-skeleton-light);
  z-index: 1;
  border-radius: 5px;
}

qw-booking-bar.change-location {
  .service-message {
    pointer-events: none;
    background-color: var(--qw-hotel-skeleton-medium);
    p {
      color: var(--qw-hotel-skeleton-medium);
    }
  }
  .qw-booking-bar__input-fields {
    .qw-input--arrow {
      border-right: solid 1px var(--qw-hotel-skeleton-medium);
      z-index: 2;
      position: relative;
      .qw-span--label .qw-input__label,
      .qw-span--label span {
        pointer-events: none;
        background-color: var(--qw-hotel-skeleton-medium);
        color: var(--qw-hotel-skeleton-medium);
        background-image: none;
        border-radius: 2px;
      }
    }
  }
  .qw-button {
    pointer-events: none;
    z-index: 2;
    background-color: var(--qw-hotel-skeleton-medium) !important;
    color: var(--qw-hotel-skeleton-medium) !important;
    position: relative;
  }
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

qw-booking-bar qw-room-notification {
  display: none;
}

qw-booking-bar .qw-booking-bar__input-fields {
  display: flex;
  width: auto;
  justify-content: flex-start;
  align-items: center;
  /* visibility: visible;
  transition: visibility 0.3s ease-in-out; */
}

qw-booking-bar qw-input .qw-input__label {
  margin-bottom: 8px;
}

qw-booking-bar .qw-booking-bar__input-fields + .qw-button {
  border: solid 0px var(--qw-hotel-primary-color);
  font-family: var(--qw-hotel-font-family-b);
  white-space: nowrap;
  background-color: var(--qw-hotel-primary-color);
  padding: 6px 16px;
  font-size: 24px;
  border-radius: 100px;
  margin: 19px 16px 21px;
  /* visibility: visible;
  transition: visibility 0.3s ease-in-out; */
}

qw-booking-bar .qw-booking-bar__input-fields qw-input {
  padding: 16px;
  border-right: solid 1px var(--qw-hotel-neutral-border);
  min-width: 160px;
  width: auto;
}

qw-booking-bar .qw-booking-bar__input-fields .qw-span--label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

qw-booking-bar .qw-booking-bar__input-fields .qw-span--label span {
  outline: none;
  padding: 0;
  font-family: var(--qw-hotel-font-family-m);
  font-size: 18px;
  color: var(--qw-hotel-neutral-dark);
  cursor: pointer;
  white-space: nowrap;
  /* overflow: hidden;
  text-overflow: ellipsis; */
}

qw-input.qw-input--arrow .qw-span--label span {
  background-image: url('#{$base-url}img/v2/select-arrow.svg');
  background-size: 11px;
  background-position: 98% center;
  background-repeat: no-repeat;
  padding-right: 24px;
}

/* qw-booking-bar .qw-booking-bar__input-fields qw-input:first-of-type label input {
  min-width: 10ch;
} */

/* ON SCROLL */

qw-booking-bar.booking--scrolling {
  background-color: var(--qw-hotel-secondary-color);
}

qw-booking-bar.booking--scrolling .qw-booking-bar__input-fields qw-input {
  padding: 8px 16px;
}

qw-booking-bar.booking--scrolling
  .qw-booking-bar__input-fields
  qw-input
  .qw-span--label
  span {
  background-color: var(--qw-hotel-secondary-color);
}

qw-booking-bar.booking--scrolling
  .qw-booking-bar__input-fields
  qw-input:first-of-type {
  border-left: solid 1px var(--qw-hotel-neutral-border);
}

qw-booking-bar.booking--scrolling .qw-booking-bar__input-fields + .qw-button {
  padding: 10px 16px;
  font-size: 16px;
  margin: 13px 24px 11px 21px;
}

qw-booking-bar.booking--scrolling qw-input .qw-input__label {
  margin-bottom: 6px;
}

/* ON SESSION ALREADY */

qw-booking-bar.booking--searched .qw-booking-bar__edit + qw-input,
qw-booking-bar.booking--searched qw-input .qw-input__label {
  display: none;
}

qw-booking-bar.booking--searched .qw-booking-bar__label--search {
  margin-left: 56px;
}
qw-booking-bar.booking--scrolling.booking--searched
  .qw-booking-bar__label--search {
  margin-left: 0px;
}

qw-booking-bar.booking--searched .qw-booking-bar__label--search p {
  color: var(--qw-hotel-neutral-medium);
  font-family: var(--qw-hotel-font-family-r);
  margin: 0;
  font-size: 15px;
  white-space: nowrap;
}
qw-booking-bar.booking--searched .qw-booking-bar__edit {
  display: flex;
  align-items: center;
  padding-left: 16px;
}

qw-booking-bar.booking--searched .qw-booking-bar__edit--text {
  color: var(--qw-hotel-accent-label);
  font-family: var(--qw-hotel-font-family-m);
  padding-right: 8px;
  margin: 0;
  text-decoration: underline;
  font-size: 18px;
  cursor: pointer;
}
qw-booking-bar.booking--searched .qw-booking-bar__edit--icon {
  background-image: url('#{$base-url}img/v2/edit-pencil.svg');
  width: 12px;
  height: 12px;
  display: inline-block;
  background-size: 12px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}

qw-booking-bar.booking--searched .qw-booking-bar__input-fields qw-input {
  border-right: solid 0px var(--qw-hotel-neutral-border);
  min-width: 0px;
  width: auto;
  position: relative;
}

qw-booking-bar.booking--searched .qw-booking-bar__input-fields qw-input:after {
  content: '\02022';
  display: inline-block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-50%, -50%);
}

qw-booking-bar.booking--searched
  .qw-booking-bar__input-fields
  qw-input:first-of-type {
  border-left: solid 0px var(--qw-hotel-neutral-border);
}

qw-booking-bar.booking--searched
  .qw-booking-bar__input-fields
  qw-input:first-of-type:after {
  display: none;
}

qw-booking-bar.booking--searched .qw-booking-bar__input-fields + .qw-button {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 18px;
  padding: 9px 20px;
}

qw-booking-bar.booking--scrolling.booking--searched
  .qw-booking-bar__input-fields
  + .qw-button {
  margin-top: 12px;
  margin-bottom: 12px;
}

qw-booking-bar.booking--searched qw-input.qw-input--arrow .qw-span--label span {
  background-image: url('#{$base-url}img/v2/select-arrow.svg');
  background-size: 0;
  padding-right: 0px;
}

qw-booking-bar.booking--searched {
  position: relative;
}

qw-booking-bar.booking--searched qw-room-notification {
  display: flex;
  position: absolute;
  right: 21px;
  top: 7px;
}

@media only screen and (max-width: 1550px) {
  qw-booking-bar .qw-booking-bar__input-fields qw-input {
    width: auto;
  }
}

@media only screen and (max-width: 1280px) {
  qw-booking-bar .qw-booking-bar__input-fields .qw-input__label {
    margin-bottom: 8px;
  }
  qw-booking-bar .qw-booking-bar__input-fields .qw-span--label span {
    font-size: 18px;
  }
  qw-booking-bar .qw-booking-bar__input-fields + .qw-button {
    font-size: 21px;
  }
  qw-booking-bar .qw-booking-bar__input-fields qw-input {
    padding: 14px 20px;
    margin-right: 0;
    min-width: 150px;
  }
}

@media only screen and (max-width: 1144px) {
  qw-booking-bar .qw-booking-bar__input-fields {
    width: 94%;
  }
  qw-booking-bar .qw-booking-bar__input-fields + .qw-button {
    font-size: 18px;
    padding: 12px 22px;
  }
  qw-booking-bar .qw-booking-bar__input-fields qw-input {
    min-width: 140px;
  }
}
@media only screen and (max-width: 1024px) {
  qw-booking-bar .qw-booking-bar__input-fields .qw-input__label {
    font-size: 13px;
  }
  qw-booking-bar .qw-booking-bar__input-fields {
    width: 96%;
  }
  qw-booking-bar .qw-booking-bar__input-fields qw-input {
    margin-right: 0px;
  }
  qw-booking-bar .qw-booking-bar__input-fields .qw-span--label span {
    font-size: 16px;
  }
}

@media only screen and (max-width: 738px) {
  qw-booking-bar {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 0;
    padding: 0 10px;
  }

  qw-booking-bar .qw-booking-bar__edit {
    flex-direction: row;
    flex: 1;
    justify-content: center;
    position: relative;
    padding: 0;
  }

  qw-booking-bar .qw-button.qw-mobile--continue {
    margin: 0 0 0 10px;
    font-size: 18px;
    padding: 9px 20px;
    &:after {
      content: '';
      display: block;
      width: 1px;
      background-color: #dadada;
      height: 80%;
      top: 10%;
      position: absolute;
      left: -10px;
    }
  }

  qw-booking-bar.booking--searched .qw-booking-bar__edit {
    padding-left: 0;
  }
  qw-booking-bar .qw-button {
    margin: 0px;
    font-size: 16px;
    padding: 16px 24px;
    background-color: var(--qw-hotel-primary-color);
    border: solid 0px var(--qw-hotel-primary-color);
    font-family: var(--qw-hotel-font-family-b);
    white-space: nowrap;
    border-radius: 100px;
  }
  qw-booking-bar .qw-booking-bar__input-fields {
    width: 100%;
    display: none;
  }
  qw-booking-bar .qw-booking-bar__input-fields qw-input {
    min-width: 0px;
  }
  qw-booking-bar .qw-booking-bar__input-fields qw-input:first-of-type {
    width: 100%;
    margin-right: 0;
  }

  qw-booking-bar .qw-booking-bar__input-fields qw-input {
    display: none;
  }
  qw-booking-bar .qw-booking-bar__input-fields qw-input:first-of-type {
    display: flex;
  }
  qw-booking-bar .qw-booking-bar__input-fields qw-input .qw-input__label {
    font-size: 15px;
  }
}
